module.exports = "/_next/static/images/prestaShop17-5b162de5dc1e90306268186dc2fc9e29.png";